var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Communication/Comment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09182 15.3042C2.84396 9.78675 6.90306 3.75 12.8609 3.75H13.1823C17.6379 3.75 21.2499 7.36201 21.2499 11.8176C21.2499 16.7785 17.2284 20.8 12.2676 20.8H4.44731C4.12905 20.8 3.84545 20.5991 3.73982 20.2989C3.63419 19.9987 3.72954 19.6645 3.97769 19.4652L5.94918 17.8819C6.03538 17.8127 6.06587 17.6951 6.02416 17.5927L5.09182 15.3042ZM12.8609 5.25C7.96834 5.25 4.63502 10.2074 6.48096 14.7383L7.4133 17.0268C7.7053 17.7435 7.49184 18.5669 6.88842 19.0515L6.57897 19.3H12.2676C16.4 19.3 19.7499 15.95 19.7499 11.8176C19.7499 8.19044 16.8095 5.25 13.1823 5.25H12.8609Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.e97bf9802f2cc240c5f17e8113aae6ab.svg";
export { ForwardRef as ReactComponent };